module.exports = __webpack_public_path__ + "static/media/shutterstock_620003576.6abb26d1.jpg";